import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import Datos from "../../utilidades/Colecciones.json";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function SelectOrderCole(){
  const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const pestanaLabel2 = useRef(null);
    const selectOrderOrder = useRef(null);
    const [optionsOrder, setOptionsOrder] = useState([]);
    const [selectedOptionOrder, setSelectedOptionOrder] = useState("");

    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    const handleSelectChangeOrder = (event) => {
      const order = event.target.value;
      setSelectedOptionOrder(order);
      _updateFiltros({camposOrden:order});
      $("#search").trigger("click");
    }
    useEffect(() => {
        if (pestanaLabel2 !== null) {
          CambioIdioma.valida(var_ingles, pestanaLabel2);
        }
        if (selectOrderOrder !== null) {
          let x=[];
            if (var_ingles === "es") {
              setOptionsOrder(Datos[0].OrderTodos.español);
              x=Datos[0].OrderTodos.español;

            } else {
              setOptionsOrder(Datos[0].OrderTodos.ingles);
              x=Datos[0].OrderTodos.ingles;
            }
          const valor = x[0].value;
          setSelectedOptionOrder(valor)
          _updateFiltros({camposOrden:valor});
        }
    }, []);

    return(
      <div
      className="col-sm-12 col-md-11 col-lg-4"
      id="coleccionesOrder">
      <div className="row">
        <div
          className="form-check-inline col-sm-12 col-md-11 col-lg-1 col-11"
        >
          <div id="labelPestana2">
            <span id="pestanaLabel2" ref={pestanaLabel2}></span>
          </div>
        </div>
        <div className="tamChec2 form-check-inline col-md-11 col-lg-7 col-11">
          <select
            className="form-select"
            ref={selectOrderOrder}
            value={selectedOptionOrder}
            onChange={handleSelectChangeOrder}
            name="Pestana"
            id="selectOrder"
          >
            {optionsOrder.map((option) => (
              <option key={"coleccionesBuscadorOrden-" + option.value} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
    );
};